/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_EmptyInputs */

const cs_entity_picker_empty = /** @type {(inputs: Entity_Picker_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic nenalezeno. Zkuste jméno, e-mail, telefon, adresu nebo číslo zakázky.`)
};

const en_entity_picker_empty = /** @type {(inputs: Entity_Picker_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing found. Try a name, email, phone, address, or listing number.`)
};

/**
* | output |
* | --- |
* | "Nothing found. Try a name, email, phone, address, or listing number." |
*
* @param {Entity_Picker_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_empty = /** @type {((inputs?: Entity_Picker_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_empty(inputs)
	return cs_entity_picker_empty(inputs)
});